



























































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {QingApp} from '../../entity/QingApp';
import {QingAppDto} from '../../dto/QingAppDto';
import {Customer} from '@/entity/Customer';
import {CustomerDto} from '@/dto/CustomerDto';
import KeShangSelect from '@/components/QingApp/KeShangSelect.vue';

@Component({
  components: {KeShangSelect},
})
export default class QingAppForm extends Vue {
  @Prop({default: () => new QingApp()})
  public readonly value!: QingApp;
  loading = false;

  public async saveQingApp() {
    const nf = this.$q.notify({
      type: 'ongoing',
      message: '正在处理...',
      timeout: 0,
    });
    try {
      this.loading = true;
      this.handleInput(await QingAppDto.save(this.value));
      this.$q.notify({message: '提交成功', color: 'green'});
      this.$emit('submit');
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    } finally {
      this.loading = false;
    }
  }


  public handleInput(value?: QingApp) {
    if (typeof value !== 'undefined') {
      this.$emit('input', value);
    } else {
      this.$emit('input', this.value);
    }
  }


}
